/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Table, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faRotate } from "@fortawesome/free-solid-svg-icons";
import { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/rootReducer";
import { ROLE } from "../../../utils/enums";
import VerifyDomain from "./verifyDomain";
import useAxios from "../../../hooks/useAxios";
import { API_ENDPOINTS } from "../../../constants/api";
import { toaster } from "../../../utils/toast";
import useSidebar from "../../../hooks/useSidebar";
import XLoader from "../../../component/loader/XLoader";

const Domains: FC = () => {
  const [verifyModal, setVerifyModal] = useState(false);
  const [domains, setDomains] = useState<any[]>([]);
  const [dnsDetailData, setDnsDetailData] = useState();
  const { isLoading, postData } = useAxios();
  const { onShowSidebar } = useSidebar();
  const { role_id, selectedLocationId } = useSelector((state: RootState) => state.user);

  useEffect(() => {
    getDomainList();
  }, [verifyModal, selectedLocationId]);

  const verifyDomainHandleClose = () => setVerifyModal(false);
  const verifyDomainHandleShow = () => setVerifyModal(true);
  const getDomainList = async () => {
    try {
      const payload = selectedLocationId ? { locationId: selectedLocationId } : {};
      const response = await postData(API_ENDPOINTS.GET_ALL_DOMAINS, payload);
      setDomains(response?.data ?? []);
    } catch (error) {
      toaster({ success: false, message: "error fetching domains" });
    }
  }
  const checkVerified = async (email: string) => {
    try {
      let payLoad = { email };
      const response = await postData(API_ENDPOINTS.DOMAIN_DETAIL, payLoad);
      const { data } = response;
      if (!data.is_verified) {
        setDnsDetailData(data);
        verifyDomainHandleShow();
      } else {
        domains && setDomains(prev => prev.map(domain => 
          domain.email === email ? { ...domain, status: true } : domain
        ));
      }
    } catch (error) {
      toaster({ success: false, message: "error fetching domains" });
    }
  }

  return (
    <div>
      <div className="main-title d-flex align-items-center justify-content-between">
        <h2>
          <span className="d-lg-none cursor-pointer" onClick={() => onShowSidebar()}>
            <FontAwesomeIcon icon={faBars} />
          </span>
          Domains
        </h2>
        <Button
          variant="primary"
          type="button"
          className="btn-theme d-flex align-items-center"
          onClick={() => {
            setDnsDetailData(undefined);
            verifyDomainHandleShow();
          }}
        >
          Add & Verify Domain
        </Button>
      </div>
      <div className="contact-details setting-domains">
        <div className="info-box">
          <h2>Email Domains</h2>
          <p>
            Your email domains control how your emails are sent through
            PatientCampaign. Verifying and authenticating your domain helps your
            hard work get to your customers' inboxes.
          </p>
          {verifyModal && (
            <VerifyDomain
              show={verifyModal}
              handleClose={verifyDomainHandleClose}
              dnsDetail={dnsDetailData}
            />
          )}
          <div className="table-listing all-contacts users-list position-relative px-0">
            <Table responsive>
              <thead>
                <tr>
                  <th>Email / Domain</th>
                  <th>Location / Scope</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
                
              <tbody>
                {!isLoading && domains.map((v) => {
                  const { id, email, status, location_name, location_id } = v;
                  const canVerify = [ROLE.ORG, ROLE.ACCOUNT_ADMIN].includes(+role_id) || (+role_id === ROLE.LOCATION_ADMIN && location_id !== null);

                  return (
                    <tr key={id}>
                      <td>
                        {status ? (
                          <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id={`tooltip-verified-${id}`}>This domain is verified and active</Tooltip>}
                          >
                            <span>{email}</span>
                          </OverlayTrigger>
                        ) : (
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id={`tooltip-unverified-${id}`}>
                                {canVerify
                                  ? "This domain is unverified. Click 'Check Status' to verify or view DNS records."
                                  : "Only organisation admins can verify organisation-level domains"}
                              </Tooltip>
                            }
                          >
                            <span className={canVerify ? "" : "text-muted"}>{email}</span>
                          </OverlayTrigger>
                        )}
                      </td>
                      <td>
                        <span>{location_name || "Organisation-wide (All Locations)"}</span>
                      </td>
                      <td>
                        <span className={`status-badge ${status ? "green" : "#7BAFD4"}`}>
                          {status ? "Verified" : "Unverified"}
                        </span>
                      </td>
                      <td>
                        {!status && canVerify ? (
                          <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id={`tooltip-check-${id}`}>Check status & view DNS details</Tooltip>}
                          >
                            <span
                              className="cursor-pointer d-inline-flex align-items-center justify-content-center"
                              style={{
                                width: "32px",
                                height: "32px",
                                borderRadius: "6px",
                                backgroundColor: "#EEF2F6",
                                color: "#13294B",
                                fontSize: "14px",
                              }}
                              onClick={() => checkVerified(email)}
                            >
                              <FontAwesomeIcon icon={faRotate} />
                            </span>
                          </OverlayTrigger>
                        ) : (
                          <span className="text-muted" style={{ fontSize: "14px" }}>-</span>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
            {isLoading && <XLoader />}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Domains;


